import { createContext, useContext, useState } from 'react'
import { getOfficeMenus } from '../lib/api-services/cmsPageService'

export const OfficeSiteContext = createContext()

export const OfficeSiteProvider = ({ children }) => {
  const defaultState = {
    officeId: null,
    officeName: null,
    officePath: null,
    searchSettings: null,
    menus: null,
  }
  const [state, setState] = useState(defaultState)

  const reset = () => {
    setState(defaultState)
  }

  const enableSite = async (
    officeId,
    officeName,
    officePath,
    searchSettings
  ) => {
    const menuData = await getOfficeMenus(officeId)
    const { mainMenu, megaNavMenus } = extractOfficeMegaNav(menuData)

    setState({
      officeId: officeId,
      officeName: officeName,
      officePath: officePath,
      searchSettings: searchSettings,
      mainMenu,
      megaNavMenus,
    })
  }

  return (
    <OfficeSiteContext.Provider
      value={{
        currentSite: state,
        resetSite: reset,
        enableSite: enableSite,
      }}
    >
      {children}
    </OfficeSiteContext.Provider>
  )
}

const extractOfficeMegaNav = (menuData) => {
  if (!menuData || !Array.isArray(menuData)) {
    return { mainMenu: [], megaNavMenus: [] }
  }

  const mainMenu =
    menuData
      .find((e) => {
        return e.handle.includes('main_menu')
      })
      ?.menu_items?.map(({ value }) => {
        return {
          label: value.link_text || value.label,
          url: value.link_page
            ? value.link_page.path
            : value.link_url + value.url_append,
        }
      }) || []

  const megaNavMenus = menuData
    ?.filter((e) => e.handle.startsWith('mega_nav'))
    ?.map((megaNavSection) => {
      const items = megaNavSection.menu_items || []
      if (items.length === 0) return null

      const [first, ...rest] = items

      const headingLabel = first.value.link_text || first.value.label
      const headingUrl = first.value.link_page
        ? first.value.link_page.path
        : first.value.link_url + first.value.url_append

      return {
        id: headingLabel,
        label: headingLabel,
        url: headingUrl,
        subNavItems: rest.map(({ value }) => ({
          label: value.link_text || value.label,
          url: value.link_page
            ? value.link_page.path
            : value.link_url + value.url_append,
        })),
      }
    })
    .filter(Boolean)

  return { mainMenu, megaNavMenus }
}

export const useOfficeSiteContext = () => useContext(OfficeSiteContext)
